(function () {
	'use strict';

	// ─── Atomic forms (Kontakt page) ────────────────────────────────────────────
	// 1. Suggestions: an input with data-options="A|B|C" (Elementor: Attributes)
	//    gets a <datalist>, so the visitor can pick a suggestion or type freely
	//    (Figma "Kuidas meist kuulsid?": "Vali või kirjuta lühidalt").
	// 2. Analytics: Elementor submits the form over AJAX and only marks the
	//    result with a form-state-success class, so watch for it and push the
	//    Figma event `generate_lead` to the dataLayer (GTM / GA4). No personal
	//    data is sent; only the form name and the self-reported source.

	function addSuggestions(input) {
		var options = (input.getAttribute('data-options') || '').split('|');
		var id = 'arelis-options-' + (input.id || input.name);

		if (document.getElementById(id)) {
			return;
		}

		var list = document.createElement('datalist');
		list.id = id;
		options.forEach(function (label) {
			label = label.trim();
			if (label) {
				var option = document.createElement('option');
				option.value = label;
				list.appendChild(option);
			}
		});
		input.after(list);
		input.setAttribute('list', id);
	}

	function trackLeads(form) {
		var source = form.querySelector('[name="self_reported_source"]');
		var lastSource = '';

		// The form is reset right after success, so read the value on submit.
		form.addEventListener('submit', function () {
			lastSource = source ? source.value.trim() : '';
		});

		var wasSuccess = false;

		new MutationObserver(function () {
			var isSuccess = form.classList.contains('form-state-success');
			var justSucceeded = isSuccess && !wasSuccess;
			wasSuccess = isSuccess;
			if (!justSucceeded) {
				return;
			}

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'generate_lead',
				form_name: form.dataset.formName || 'Kontakt',
				self_reported_source: lastSource || undefined
			});
		}).observe(form, { attributes: true, attributeFilter: ['class'] });
	}

	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('form.e-form-base input[data-options]').forEach(addSuggestions);
		document.querySelectorAll('form.e-form-base').forEach(trackLeads);
	});

})();
